module.exports = __webpack_public_path__ + "static/media/badge-googleplay.9c984415.svg";